import {
  AI_TRANSLATE_JSON,
  SET_AI_TARGET_LANG,
  SET_AI_JSON,
  SET_AI_SAVED,
  RESET_AI_STATE,
} from '../constants/AiTranslation';

const initialState = {
  translating: false,
  aiTargetLang: null,
  aiJson: null,
  aiSaved: false,
  replacedKeys: null,
  error: null,
};

const aiTranslation = (state = initialState, action) => {
  switch (action.type) {
    case AI_TRANSLATE_JSON.PENDING:
      return {
        ...state,
        translating: true,
        error: null,
      };
    case AI_TRANSLATE_JSON.FULFILLED:
      return {
        ...state,
        translating: false,
        aiJson: action.payload.resultJson,
        replacedKeys: action.payload.restoredKeys,
      };
    case AI_TRANSLATE_JSON.REJECTED:
      return {
        ...state,
        translating: false,
        error: action.payload,
      };
    case SET_AI_TARGET_LANG:
      return {
        ...state,
        aiTargetLang: action.payload,
      };
    case SET_AI_JSON:
      return {
        ...state,
        aiJson: action.payload,
      };
    case SET_AI_SAVED:
      return {
        ...state,
        aiSaved: action.payload,
      };
    case RESET_AI_STATE:
      return initialState;
    default:
      return state;
  }
};

export default aiTranslation;
